import React, { useEffect, useState } from "react";
import * as moment from "moment";
import styled from "styled-components";
import DatePicker from "web/components/form-elements/DatePicker";
import TimePickerInput from "web/components/form-elements/TimePickerInput"
import AlertModal from "web/components/AlertModal";
import { Modal, ModalBody } from "reactstrap";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { Field } from "formik";
import RadioButton from "web/components/form-elements/RadioButton";
import Select from "web/components/form-elements/Select";

const RecurringOrderModal = (props) => {
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [modalLink, setModalLink] = useState("/");
    const toggleModal = () => setModal(!modal);
    const [formikPageValues, setFormikPageValues] = useState(props?.formikValues)
    const weekList = [{ label: 'Mon', value: 'MONDAY' }, { label: 'Tue', value: 'TUESDAY' }, { label: 'Wed', value: 'WEDNESDAY' }, { label: 'Thu', value: 'THURSDAY' },
    { label: 'Fri', value: 'FRIDAY' }, { label: 'Sat', value: 'SATURDAY' }, { label: 'Sun', value: 'SUNDAY' }]

    const monthOptionSelectDropDownOneList = [{ label: 'First', value: 'FIRST' }, { label: 'Second', value: 'SECOND' }, { label: 'Third', value: 'THIRD' },
    { label: 'Fourth', value: 'FOURTH' }, { label: 'Last', value: 'LAST' }]
    const monthOptionSelectDropDownTwoList = [{ label: 'Mon', value: 'MONDAY' }, { label: 'Tue', value: 'TUESDAY' }, { label: 'Wed', value: 'WEDNESDAY' }, { label: 'Thu', value: 'THURSDAY' },
    { label: 'Fri', value: 'FRIDAY' }, { label: 'Sat', value: 'SATURDAY' }, { label: 'Sun', value: 'SUNDAY' }]

    const updateFormikValueFunction = (fieldName, fieldValue) => {
        props.setFieldValueFunction(fieldName, fieldValue)
    }

    useEffect(() => {
        setFormikPageValues(props?.formikValues)
    }, [props])

    const toggleModalFunction = type => {
        let startDateCheck = moment(formikPageValues?.recStartDateTemp)
        let endDateCheck = moment(formikPageValues?.recEndDateTemp)
        if (type === 'cancel') {
            updateFormikValueFunction('recTypeTemp', formikPageValues?.recType)
            updateFormikValueFunction('recStartDateTemp', formikPageValues?.recStartDate)
            updateFormikValueFunction('recEndDateTemp', formikPageValues?.recEndDate)
            updateFormikValueFunction('weeklyRecEveryTemp', formikPageValues?.weeklyRecEvery)
            updateFormikValueFunction('weeklyRecDaysTemp', formikPageValues?.weeklyRecDays)
            updateFormikValueFunction('monthlyRecTypeTemp', formikPageValues?.monthlyRecType)
            updateFormikValueFunction('monthlyDayTypeRecDayTemp', formikPageValues?.monthlyDayTypeRecDay)
            updateFormikValueFunction('monthlyDayTypeRecEveryTemp', formikPageValues?.monthlyDayTypeRecEvery)
            updateFormikValueFunction('monthlyCustomeTypeStartDateOfWeekTemp', formikPageValues?.monthlyCustomeTypeStartDateOfWeek)
            updateFormikValueFunction('monthlyCustomeTypeStarWeektDayOfWeekTemp', formikPageValues?.monthlyCustomeTypeStarWeektDayOfWeek)
            updateFormikValueFunction('monthlyCustomeTypeRecEveryTemp', formikPageValues?.monthlyCustomeTypeRecEvery)
            props.toggleModal(type)
        } else if (type === 'submit') {
            if (formikPageValues?.recTypeTemp === 'WEEKLY' && formikPageValues?.weeklyRecDaysTemp?.length === 0) {
                setModalContent("Please select the week days for the recurring order.");
                setModalLink();
                toggleModal();
            } else if (endDateCheck.isBefore(startDateCheck)) {
                setModalContent("End date should not be before start date.");
                setModalLink();
                toggleModal();
            } else {
                updateFormikValueFunction('recType', formikPageValues?.recTypeTemp)
                updateFormikValueFunction('recStartDate', formikPageValues?.recStartDateTemp)
                updateFormikValueFunction('recEndDate', formikPageValues?.recEndDateTemp)
                updateFormikValueFunction('weeklyRecEvery', formikPageValues?.weeklyRecEveryTemp)
                updateFormikValueFunction('weeklyRecDays', formikPageValues?.weeklyRecDaysTemp)
                updateFormikValueFunction('monthlyRecType', formikPageValues?.monthlyRecTypeTemp)
                updateFormikValueFunction('monthlyDayTypeRecDay', formikPageValues?.monthlyDayTypeRecDayTemp)
                updateFormikValueFunction('monthlyDayTypeRecEvery', formikPageValues?.monthlyDayTypeRecEveryTemp)
                updateFormikValueFunction('monthlyCustomeTypeStartDateOfWeek', formikPageValues?.monthlyCustomeTypeStartDateOfWeekTemp)
                updateFormikValueFunction('monthlyCustomeTypeStarWeektDayOfWeek', formikPageValues?.monthlyCustomeTypeStarWeektDayOfWeekTemp)
                updateFormikValueFunction('monthlyCustomeTypeRecEvery', formikPageValues?.monthlyCustomeTypeRecEveryTemp)

                // updating the start date selected to the request delivery date
                updateFormikValueFunction(`addMoreArrList.[${0}].requestDeliveryDate`, formikPageValues?.recStartDateTemp)
                updateFormikValueFunction(`apptEdit`, formikPageValues?.addMoreArrList[0].appt)
                updateFormikValueFunction(`apptToEdit`, formikPageValues?.addMoreArrList[0].apptTo)
                updateFormikValueFunction(`addMoreArrList.[${0}].appt`, formikPageValues?.addMoreArrList[0].appt)
                updateFormikValueFunction(`addMoreArrList.[${0}].apptTo`, formikPageValues?.addMoreArrList[0].apptTo)

                props.toggleModal(type)
            }
        }
    }

    return (
        <>
            <Modal
                isOpen={true}
                toggle={props?.toggle}
                backdrop={"static"}
                centered={true}
                size='lg'
                className='custom-modal-style-rec-modal'
            >
                <RecurringModalWrapper>
                    <ModalBody>
                        <div className="header-wrapper">
                            <h6>Setup Recurring Order</h6>
                            <img src={CloseIcon} alt="close-icon" onClick={() => toggleModalFunction('cancel')} />
                        </div>

                        <div className="modal-description">
                            <p>Fill out following information to outline your weekly, or monthly requirements.</p>
                        </div>

                        <h6 className="content-title">Recurring Order<span className="star">*</span></h6>

                        <div className="recc-content">
                            <div className="content-header">
                                <p className={formikPageValues?.recTypeTemp === 'WEEKLY' && 'header-border-style'}
                                    onClick={() => updateFormikValueFunction('recTypeTemp', 'WEEKLY')}
                                >Weekly</p>
                                <p className={formikPageValues?.recTypeTemp === 'MONTHLY' && 'header-border-style'}
                                    onClick={() => updateFormikValueFunction('recTypeTemp', 'MONTHLY')}
                                >Monthly</p>
                            </div>
                            <div className="recc-options" style={{ borderStartStartRadius: formikPageValues?.recTypeTemp === 'WEEKLY' ? '0px' : '5px' }}>
                                {
                                    formikPageValues?.recTypeTemp === 'WEEKLY' ?
                                        <div className="recc-option-weekly">
                                            <div>
                                                Recur every&nbsp;&nbsp;&nbsp;

                                                <input type="number" max='99' className="week-input" value={formikPageValues?.weeklyRecEveryTemp}
                                                    onChange={(e) => (e.target.value < 100) && updateFormikValueFunction('weeklyRecEveryTemp', e.target.value)} />&nbsp;&nbsp;

                                                week(s) on:
                                            </div>
                                            <div className="week-options-style">
                                                {weekList.map((items) => {
                                                    return (
                                                        <div style={{ display: 'flex' }}>
                                                            <input
                                                                className="custom-checkbox"
                                                                id={items.value}
                                                                type="checkbox"
                                                                checked={formikPageValues?.weeklyRecDaysTemp?.includes(items.value)}
                                                                onChange={e => {
                                                                    let checkedValues = formikPageValues?.weeklyRecDaysTemp
                                                                    if (e.target.checked) checkedValues.push(e.target.id)
                                                                    else checkedValues = checkedValues.filter(data => data !== e.target.id)
                                                                    updateFormikValueFunction('weeklyRecDaysTemp', checkedValues)
                                                                }}
                                                            />
                                                            <label for={items.label} class="checkbox-label">{items.label}</label>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                        :
                                        <div className="recc-option-monthly">
                                            <div style={{ display: 'flex', marginBottom: '20px' }}>
                                                <Field
                                                    component={RadioButton}
                                                    name="monthlyRecTypeTemp"
                                                    id='DAY'
                                                    defaultValue={formikPageValues?.monthlyRecTypeTemp}
                                                    onSelect={(e) => updateFormikValueFunction('monthlyRecTypeTemp', 'DAY')}
                                                    label=''
                                                />
                                                <div>
                                                    Day&nbsp;&nbsp;

                                                    <input type="number" max='99' className="month-input" value={formikPageValues?.monthlyDayTypeRecDayTemp}
                                                        onChange={(e) => (e.target.value < 100) && updateFormikValueFunction('monthlyDayTypeRecDayTemp', e.target.value)} />&nbsp;&nbsp;

                                                    of every&nbsp;&nbsp;

                                                    <input type="number" max='99' className="month-input" value={formikPageValues?.monthlyDayTypeRecEveryTemp}
                                                        onChange={(e) => (e.target.value < 100) && updateFormikValueFunction('monthlyDayTypeRecEveryTemp', e.target.value)} />&nbsp;&nbsp;

                                                    month(s)
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex' }}>
                                                <Field
                                                    component={RadioButton}
                                                    name="monthlyRecTypeTemp"
                                                    id='CUSTOM'
                                                    defaultValue={formikPageValues?.monthlyRecTypeTemp}
                                                    onSelect={(e) => updateFormikValueFunction('monthlyRecTypeTemp', 'CUSTOM')}
                                                    label=''
                                                />
                                                <div style={{ display: 'flex', flexWrap: 'wrap', position: 'relative', bottom: '5px' }}>
                                                    <span className="filler-words-span">The</span>&nbsp;&nbsp;

                                                    <div style={{ width: '118px' }}>
                                                        <Select
                                                            name="monthlyCustomeTypeStartDateOfWeekTemp"
                                                            data={monthOptionSelectDropDownOneList}
                                                            placeholder=""
                                                            searchable={true}
                                                            onChangeHandler={(value, response) => updateFormikValueFunction('monthlyCustomeTypeStartDateOfWeekTemp', value)}
                                                        /></div>
                                                    &nbsp;&nbsp;
                                                    <div style={{ width: '100px' }}>
                                                        <Select
                                                            name="monthlyCustomeTypeStarWeektDayOfWeekTemp"
                                                            data={monthOptionSelectDropDownTwoList}
                                                            placeholder=" "
                                                            searchable={true}
                                                            onChangeHandler={(value, response) => updateFormikValueFunction('monthlyCustomeTypeStarWeektDayOfWeekTemp', value)}
                                                        /></div>

                                                    <span className="filler-words-span">of every</span>&nbsp;&nbsp;

                                                    <input type="number" max='99' className="month-input" value={formikPageValues?.monthlyCustomeTypeRecEveryTemp}
                                                        onChange={(e) => (e.target.value < 100) && updateFormikValueFunction('monthlyCustomeTypeRecEveryTemp', e.target.value)} />&nbsp;&nbsp;

                                                    <span className="filler-words-span">month(s)</span>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>

                        <div className="date-wrapper">
                            <div style={{ marginRight: '20px' }}>
                                <p>Start Date<span className="star">*</span></p>
                                <div style={{ marginTop: '18px', maxWidth: '150px' }}>
                                    <DatePicker
                                        className="responsive"
                                        name='recStartDateTemp'
                                        placeholderText=""
                                        selectedDate={formikPageValues?.recStartDateTemp || ''}
                                        // value={formikPageValues?.recStartDateTemp}
                                        maxDOBirth={formikPageValues?.recEndDateTemp}
                                        callBackFun={() => {
                                        }}
                                    />
                                </div>
                            </div>
                            <div>
                                <p>End Date<span className="star">*</span></p>
                                <div style={{ marginTop: '18px', maxWidth: '150px' }}>
                                    <DatePicker
                                        className="responsive"
                                        name='recEndDateTemp'
                                        placeholderText=""
                                        selectedDate={formikPageValues?.recEndDateTemp || ''}
                                        // value={formikPageValues?.recEndDateTemp}
                                        minDOBirth={formikPageValues?.recStartDateTemp}
                                        callBackFun={() => {

                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ marginLeft: '15px' }}>
                                <p>Appointment Window<span className="star">*</span></p>
                                <div style={{ display: 'flex', 'margin-top':'-10px' }}>
                                    <div style={{ marginRight: '20px', maxWidth: '100px' }}>
                                        <span className="other-label">From</span>
                                        <TimePickerInput
                                            className="responsive"
                                            name={`addMoreArrList.[${0}].appt`}
                                            //editResponse={editResponse}
                                            showErrorMessages={true}
                                            fromValue={formikPageValues?.appt}
                                            selectedValue={formikPageValues?.addMoreArrList[0]?.appt}
                                            // toValue={formikPageValues?.apptTo}
                                            onChangeHandler={(time) => {
                                                if (time === "00:00") {
                                                }
                                            }}
                                        />
                                    </div>
                                    <div style={{ marginRight: '20px', maxWidth: '100px' }}>
                                        <span className="other-label">To</span>
                                        <TimePickerInput
                                            className="responsive"
                                            name={`addMoreArrList.[${0}].apptTo`}
                                            // editResponse={editResponse}
                                            endTime="23:00"
                                            fromValue={formikPageValues?.appt}
                                            toValue={formikPageValues?.apptTo}
                                            selectedValue={formikPageValues?.addMoreArrList[0]?.apptTo}
                                            showErrorMessages={true}
                                            onChangeHandler={(time) => {
                                                if (time === "00:00") {
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="button-wrapper">
                            <button onClick={() => toggleModalFunction('cancel')}>
                                Cancel
                            </button>
                            <button onClick={() => toggleModalFunction('submit')}>
                                Submit
                            </button>
                        </div>
                    </ModalBody>
                </RecurringModalWrapper>
            </Modal>

            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title="Alert"
                content={modalContent}
                link={modalLink}
                className="alert-msg-container"
                InnerClassName="alert-msg"
            />
        </>
    )
};

export default RecurringOrderModal;

const RecurringModalWrapper = styled.div`
    .modal-body{
        padding: 0px !important;
    }
    .header-wrapper{
        display: flex;
        justify-content: space-between;
        padding: 18px;
        background: #0000000d;
        border-radius: 5px 5px 0 0;
        h6{
            font-weight: bold;
            font-size: 18px;
        }
        img{
            height: 20px;
            width: 20px;
            cursor: pointer;
        }
    }
    .file-input-wrapper .MuiFormControl-root{
        border: none;
        border-bottom: 1px solid #E0E0E0 !important;
    }
    .custom-date-piker .app-input-text{
        border: none;
        border-bottom: 1px solid #E0E0E0 !important;
    }
    .custom-date-piker .app-input-text input{
        border: none;
    }
    .other-label {
        color: #70707080;
        font-size: clamp(10px,.729vw,14px);
    }
    .modal-description{
        display: flex;
        justify-content: center;
        padding: 25px;
    }
    .content-title{
        font-weight: bold;
        padding-left: 20px;
    }
    .recc-content{
        padding: 20px;
        .content-header{
            display: flex;
            p{
                padding: 10px 30px 10px 30px;
                cursor: pointer;
            }
            .header-border-style{
                border: 1px solid #00000033;
                box-shadow: -8px -8px 10px -10px #00000026;
                border-radius: 5px 5px 0px 0px;
                margin-bottom: -1px;
                background: #fff;
                border-bottom: 1px solid #fff;
                color: #005586;
            }
        }
        .recc-options{
            border: 1px solid #00000033;
            box-shadow: 0px 4px 10px 0px #00000026;
            border-radius: 5px;
            .recc-option-weekly{
                padding: 20px;
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
                }

                input[type="number"] {
                -moz-appearance: textfield;
                }
                .week-input{
                    border: none;
                    border-bottom: 1px solid #E0E0E0;
                    width: 40px !important;
                    outline: none;
                    padding: 0 10px;
                }
                .week-options-style{
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 20px;
                    line-height: 40px;
                    label{
                        margin-right: 20px;
                        position: relative;
                        bottom: 11px;
                    }
                    input{
                        margin-right: 7px;
                        height: 18px;
                        width: 18px;
                        accent-color: #005586;
                        appearance: auto;
                        cursor: pointer;
                    }
                }
            }
            .recc-option-monthly{
                padding: 20px;
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
                }

                input[type="number"] {
                -moz-appearance: textfield;
                }
                .month-input{
                    border: none;
                    border-bottom: 1px solid #E0E0E0;
                    width: 40px !important;
                    outline: none;
                    padding: 0 10px;
                }
                .filler-words-span{
                    display: flex;
                    align-items: center;
                }
                .react-select__control{
                    min-height: 32px;
                }
            }
        }
    }
    .date-wrapper{
        padding: 20px;
        display: flex;
        .MuiInputBase-input{
            font-size: 13px;
            width: 100px;
        }
    }
    .button-wrapper{
        padding: 20px;
        text-align: center;
        button{
            margin: 5px;
            background: linear-gradient(90deg, #55C416 0%, #367910 100%);
            padding: 8px 10px 8px 10px;
            border-radius: 4px;
            border: none;
            width: 80px;
        }
    }
    .MuiFormHelperText-root.Mui-error{
        position: relative;
        bottom: 0;
    }
`